import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStarGrey = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M5.24637 18.4616L6.60511 12.5877L6.67295 12.2944L6.4455 12.0972L1.88799 8.14598L7.91121 7.62313L8.21127 7.59708L8.32852 7.31965L10.668 1.78436L13.0074 7.31965L13.1247 7.59708L13.4247 7.62313L19.4479 8.14598L14.8904 12.0972L14.663 12.2944L14.7308 12.5877L16.0896 18.4616L10.9262 15.3469L10.668 15.1911L10.4097 15.3469L5.24637 18.4616Z",
		stroke: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgStarGrey);
export { ForwardRef as ReactComponent };
